<template>
  <b-button :class="classes" v-b-toggle.navbar :variant="variant" :style="styles" @click="onClick" :type="type" :disabled="isDisabled" :href="link" :target="target">
    <span :class="spanVerticalAllign">
      <i v-if="fa && fapos == 'left' && typeof fa === 'string'" :class="faicon" aria-hidden="true" :style="faIconStyles"></i>

      <template v-if="fa && fapos == 'left' && Array.isArray(fa)">
        <span v-for="f in fa" :key="f">
          <i :class="faclass(f)" aria-hidden="true" :style="faIconStyles"></i>
        </span>
      </template>

      <span v-if="fa && label && fapos == 'left'">&nbsp;</span>
      {{ label }}
      <span v-if="fa && label && fapos == 'right'">&nbsp;</span>

      <i v-if="fa && fapos == 'right' && typeof fa === 'string'" :class="faicon" aria-hidden="true" :style="faIconStyles"></i>

      <template v-if="fa && fapos == 'right' && Array.isArray(fa)">
        <span v-for="f in fa" :key="f">
          <i :class="faclass(f)" aria-hidden="true" :style="faIconStyles"></i>
        </span>
      </template>

      <!-- <span v-if="fa && label">&nbsp;</span> -->
    </span>
  </b-button>
</template>

<script>
import "../../assets/scss/common.scss";
import "../../assets/scss/button.scss";

export default {
  name: "my-button",

  props: {
    spanVerticalAllign: {
      type: String,
      default: "vertical-allign-sub",
    },
    label: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    link: {
      type: String,
      default: "",
    },
    target: {
      type: String,
      default: "",
    },
    fa: {
      default: "",
    },
    faIconColor: {
      type: String,
      default: "",
    },
    faIconSize: {
      type: String,
      default: "",
    },
    faIconWeight: {
      type: String,
      default: "",
    },
    fapos: {
      default: "left",
    },
    size: {
      type: String,
      validator: function(value) {
        return ["small", "medium", "large"].indexOf(value) !== -1;
      },
    },
    classes: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    minwidth: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    inputGroup: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    faicon() {
      if (this.fa) {
        return this.faclass(this.fa);
      } else {
        return "";
      }
    },

    styles() {
      let styleString = "";

      styleString += this.width ? " width: " + this.width + "; " : "";
      styleString += this.height ? " height: " + this.height + "; " : "";
      styleString += this.minwidth ? " min-width: " + this.minwidth + "; " : "";
      styleString += this.inputGroup ? "border-top-left-radius: 0px !important; border-bottom-left-radius: 4px !important;" : "";

      return styleString;
    },

    faIconStyles() {
      let styleString = "";
      styleString += this.faIconColor ? "color: " + this.faIconColor + "; " : "";
      styleString += this.faIconSize ? " font-size: " + this.faIconSize + "; " : "";
      styleString += this.faIconWeight ? " font-weight: " + this.faIconWeight + "; " : "";

      return styleString;
    },
  },

  methods: {
    onClick() {
      this.$emit("onClick");
    },
    faclass(icon) {
      return {
        [`icon fa fa-${icon}`]: true,
      };
    },
  },
};
</script>
